import { render } from "./Header.vue?vue&type=template&id=bcc110b2"
const script = {}

const cssModules = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=bcc110b2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__